import { BANKRUPTCY_INSURANCE_COVER_GENIUS, CANCELLATION_INSURANCE_COVER_GENIUS, CHECK_IN_BAGGAGE, COMPREHENSIVE_INSURANCE_COVER_GENIUS, SEAT_MAP, TRAVEL_INSURANCE_COVER_GENIUS, CABIN_BAGGAGE } from '../../products';
export const UPSELL_TYPES = {
  PROMOTIONAL: 'promotional',
  INFOMATION: 'information',
  INCLUDED: 'included'
};

// TEMPORARY while AB-testing => exclude the new design for these products in TD page
export const ancillaryCardOutOfScopeProducts = [CHECK_IN_BAGGAGE.name, SEAT_MAP.name, CABIN_BAGGAGE.name];
export const COVER_GENIUS_PRODUCT = [BANKRUPTCY_INSURANCE_COVER_GENIUS.name, CANCELLATION_INSURANCE_COVER_GENIUS.name, COMPREHENSIVE_INSURANCE_COVER_GENIUS.name, TRAVEL_INSURANCE_COVER_GENIUS.name];
export const PRODUCTS = 'products';
export const FORM_PREFIX = 'form-session-data';
//# sourceMappingURL=constants.js.map